// GA Docs for using multiple accounts on the same page
// https://developers.google.com/analytics/devguides/collection/analyticsjs/creating-trackers#working_with_multiple_trackers
import config from '../../config';
import { PageNames, SessionTrackingIdByName } from './constants';

let { debug } = config;

const tryGa = (...params) => {
    if (typeof window.ga === 'function') {
        window.ga(...params);

        return true;
    }

    return false;
};

// eslint-disable-next-line max-params
const logGa = (sessionName, eventName, ...rest) => tryGa(`${sessionName}.send`, eventName, ...rest);

export const logEvent = (sessionName, { category, action, label, value }) => {
    const success = logGa(sessionName, 'event', category, action, label, value);

    if (success && debug) {
        // eslint-disable-next-line no-console
        console.log(
            'Logged analytics event:',
            '\nsession:',
            sessionName,
            '\ncategory:',
            category,
            '\naction:',
            action,
            '\nlabel:',
            label,
            '\nvalue:',
            value,
        );
    }
};

// eslint-disable-next-line max-params
export const logPageView = (sessionName, pageName, ...rest) => {
    tryGa(`${sessionName}.set`, 'page', pageName, ...rest);
    const success = tryGa(`${sessionName}.send`, 'pageview');

    if (success && debug) {
        // eslint-disable-next-line no-console
        console.log('Logged page view:', '\nsession:', sessionName, '\npage:', pageName, '\nrest:', ...rest);
    }
};

export const initAnalytics = (sessionName, forceDebug) => {
    /* eslint-disable */
    (function (i, s, o, g, r, a, m) {
        i['GoogleAnalyticsObject'] = r;
        (i[r] =
            i[r] ||
            function () {
                (i[r].q = i[r].q || []).push(arguments);
            }),
            (i[r].l = 1 * new Date());
        (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
        a.async = 1;
        a.src = g;
        m.parentNode.insertBefore(a, m);
    })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
    /* eslint-enable */

    tryGa('create', SessionTrackingIdByName[sessionName], 'auto', sessionName);

    if (forceDebug) {
        debug = forceDebug;
    }
};

/**
 * Converts an array to a string that can be used for an event label
 * @param {array} array The array to convert
 * @param {object} valueToLabelMap An optional value to label mapping object
 * @returns {string} A string representation of the array
 */
export const arrayToLabel = (array, valueToLabelMap = {}) =>
    array
        .sort()
        .map((value) => valueToLabelMap[value] || value)
        .join(', ');

/**
 * Reduces an array of filter options ({ label, value }) to a lookup object of value to label
 * @param {array} filterOptions The list of options to reduce
 * @returns {object} A lookup object with filter values as the keys and filter labels as the values
 */
export const filterOptionsToLookup = (filterOptions = []) =>
    filterOptions.reduce((lookup, { label, value }) => {
        lookup[value] = label;

        return lookup;
    }, {});
